<!--
TODO:
* Input values are not set correctly now, fix them when you enable the form.
* Newsletter doesn't have correct value either
-->
<template>
  <div class="details">
    <p>View and edit your personal details or change your password.</p>

    <form
      class="form"
      ref="detailsForm"
      @keyup.enter="submit()"
      v-on:submit.prevent=""
    >
      <div v-if="errorMessage" class="row row--separator row--separatorTop">
        <div class="row__full">
          <p class="row__error" v-html="errorMessage" />
        </div>
      </div>

      <div class="row row--separator">
        <div class="row__full">
          <FormInput
            :value="userData.email ? userData.email : email"
            ref-name="email"
            placeholder="you@company.com"
            label="Email"
            alt-label="Use your company/organization email"
            type="email"
            class="form__input"
            autocomplete="email"
            iconSize="md"
            :icon="icon.email"
            :error="errors.email"
            :status="status.email"
            :disabled="true"
            @inputChanged="setFieldValue($event, 'email')"
            @unfocused="validate('email')"
          />
        </div>
      </div>

      <div class="row">
        <div class="row__full">
          <FormInput
            :value="userData.first_name ? userData.first_name : firstName"
            ref-name="firstName"
            placeholder="John"
            label="First name"
            alt-label="Please fill in your first name"
            type="text"
            class="form__input"
            autocomplete="given-name"
            iconSize="md"
            :icon="icon.firstName"
            :error="errors.firstName"
            :status="status.firstName"
            :disabled="true"
            @inputChanged="setFieldValue($event, 'firstName')"
            @unfocused="validate('firstName')"
          />
        </div>
      </div>

      <div class="row">
        <div class="row__full">
          <FormInput
            :value="userData.last_name ? userData.last_name : lastName"
            ref-name="lastName"
            placeholder="Doe"
            label="Last name"
            alt-label="Please fill in your last name"
            type="text"
            class="form__input"
            autocomplete="family-name"
            iconSize="md"
            :icon="icon.lastName"
            :error="errors.lastName"
            :status="status.lastName"
            :disabled="true"
            @inputChanged="setFieldValue($event, 'lastName')"
            @unfocused="validate('lastName')"
          />
        </div>
      </div>

      <div class="row row--newsletter">
        <div class="row__left">
          <FormSwitch
            v-model="newsletter"
            class="form__switch"
            style="top:50%; transform:translate(0,-50%);"
            :error="errors.newsletter"
          />
        </div>

        <div class="row__right">
          <p class="row__notice">
            I want to <span class="highlight">subscribe to Statzon's monthly newsletter</span> to receive the latest insights and updates.
          </p>
        </div>
      </div>

      <div class="row row--separator">
        <div class="row__full">
          <FormSubmit
            :status="formStatus"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7.753 18.305c-.261-.586-.789-.991-1.871-1.241-2.293-.529-4.428-.993-3.393-2.945 3.145-5.942.833-9.119-2.489-9.119-3.388 0-5.644 3.299-2.489 9.119 1.066 1.964-1.148 2.427-3.393 2.945-1.084.25-1.608.658-1.867 1.246-1.405-1.723-2.251-3.919-2.251-6.31 0-5.514 4.486-10 10-10s10 4.486 10 10c0 2.389-.845 4.583-2.247 6.305z"/></svg>'
            :disabled="true"
            @click="submit()"
          >
            {{ formStatus === 'success' ? 'Success' : 'Update details' }}
          </FormSubmit>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import FormInput from '@/components/form/Input.vue'
import FormSwitch from '@/components/form/Switch.vue'
import FormSubmit from '@/components/form/Submit.vue'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    FormInput,
    FormSwitch,
    FormSubmit
  },
  data () {
    return {
      form: false,
      formStatus: 'default',
      email: '',
      firstName: '',
      lastName: '',
      newsletter: false,
      errorMessage: '',
      errors: {
        email: false,
        firstName: false,
        lastName: false
      },
      status: {
        email: false,
        firstName: false,
        lastName: false
      },
      icon: {
        email: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 12.713l-11.985-9.713h23.971l-11.986 9.713zm-5.425-1.822l-6.575-5.329v12.501l6.575-7.172zm10.85 0l6.575 7.172v-12.501l-6.575 5.329zm-1.557 1.261l-3.868 3.135-3.868-3.135-8.11 8.848h23.956l-8.11-8.848z"/></svg>',
        firstName: '<svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M24 24h-24v-24h24v24zm-2-22h-20v20h20v-20zm-4.118 14.064c-2.293-.529-4.427-.993-3.394-2.945 3.146-5.942.834-9.119-2.488-9.119-3.388 0-5.643 3.299-2.488 9.119 1.064 1.963-1.15 2.427-3.394 2.945-2.048.473-2.124 1.49-2.118 3.269l.004.667h15.993l.003-.646c.007-1.792-.062-2.815-2.118-3.29z"/></svg>',
        lastName: '<svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M24 0v24h-24v-24h24zm-6.118 16.064c-2.293-.529-4.427-.993-3.394-2.945 3.146-5.942.834-9.119-2.488-9.119-3.388 0-5.643 3.299-2.488 9.119 1.064 1.963-1.15 2.427-3.394 2.945-2.048.473-2.124 1.49-2.118 3.269l.004.667h15.993l.003-.646c.007-1.792-.062-2.815-2.118-3.29z"/></svg>',
        password: [
          '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-5 7.723v2.277h-2v-2.277c-.595-.347-1-.984-1-1.723 0-1.104.896-2 2-2s2 .896 2 2c0 .738-.404 1.376-1 1.723zm-5-7.723v-4c0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4v4h-8z"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-10-4c0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4v4h-8v-4zm3.408 14l-2.842-2.756 1.172-1.173 1.67 1.583 3.564-3.654 1.174 1.173-4.738 4.827z"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-4.138 9.975l-1.862-1.836-1.835 1.861-1.13-1.129 1.827-1.86-1.862-1.837 1.129-1.13 1.859 1.827 1.838-1.871 1.139 1.139-1.833 1.86 1.868 1.836-1.138 1.14zm-5.862-9.975v-4c0-2.206 1.795-4 4-4s4 1.794 4 4v4h-8z"/></svg>'
        ]
      }
    }
  },
  computed: {
    userData () {
      let userData = this.$store.getters['user/getData']
      if (userData !== undefined) {
        return userData
      }

      return {}
    }
  },
  methods: {
    async submit () {
      this.errorMessage = ''

      if (this.validate('all')) {
        this.formStatus = 'loading'

        let formData = {
          hubspotutk: this.getCookie('hubspotutk'),
          email: this.email,
          password: this.password,
          first_name: this.firstName,
          last_name: this.lastName,
          referral_code: this.referralCode.length > 0 ? this.referralCode : '',
          newsletter: this.newsletter,
          step: 'a'
        }

        try {
          let response = await this.$store.dispatch('user/register', formData)

          if (response.data.status === 'ok') {
            this.formStatus = 'success'
            this.$store.dispatch('app/setVerificationHash', response.data.attributes.verification_hash)
            this.$store.dispatch('app/setRegistrationEmail', response.data.attributes.email)
            this.$emit('registered')
          }
        } catch (error) {
          if (error.data) {
            if (error.data.errors) {
              this.errors = error.data.errors
              error.data.errors.forEach(err => {
                this.errorMessage += err.title + '<br>'
              })
            }
          }

          this.formStatus = 'error'
        }
      }
    },
    validate (field) {
      let valid = true

      if (field === 'email' || field === 'all') {
        if (this.email === '') {
          this.errors.email = 'Required field'
          valid = false
        } else if (this.email.length > 255) {
          this.errors.email = 'Maximum of 255 characters'
          valid = false
        } else if (this.email !== '') {
          let emailTest = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (!emailTest.test(this.email)) {
            this.errors.email = 'Email must be valid'
            valid = false
          } else {
            this.errors.email = undefined
          }
        } else {
          this.errors.email = undefined
        }

        this.status.email = this.errors.email ? 'invalid' : 'valid'
      }

      if (field === 'password' || field === 'all') {
        if (this.password === '') {
          this.errors.password = 'Required field'
          valid = false
        } else if (this.password.length < 8) {
          this.errors.password = 'Minimum of 8 characters'
          valid = false
        } else {
          this.errors.password = undefined
        }

        this.status.password = this.errors.password ? 'invalid' : 'valid'
      }

      if (field === 'firstName' || field === 'all') {
        if (this.firstName === '') {
          this.errors.firstName = 'Required field'
          valid = false
        } else if (this.firstName.length > 64) {
          this.errors.firstName = 'Maximum of 64 characters'
          valid = false
        } else {
          this.errors.firstName = undefined
        }

        this.status.firstName = this.errors.firstName ? 'invalid' : 'valid'
      }

      if (field === 'lastName' || field === 'all') {
        if (this.lastName === '') {
          this.errors.lastName = 'Required field'
          valid = false
        } else if (this.lastName.length > 64) {
          this.errors.lastName = 'Maximum of 64 characters'
          valid = false
        } else {
          this.errors.lastName = undefined
        }

        this.status.lastName = this.errors.lastName ? 'invalid' : 'valid'
      }

      if (field === 'referralCode' || field === 'all') {
        if (this.referralCode.length > 64) {
          this.errors.referralCode = 'Maximum of 64 characters'
          valid = false
        } else {
          this.errors.referralCode = undefined
        }

        this.status.referralCode = this.errors.referralCode ? 'invalid' : 'valid'
      }

      return valid
    },
    checkPasswordStrength () {
      if (this.password.length === 0) {
        this.passwordStrength = 'none'
      } else if (this.password.length >= 8) {
        if (/[A-Z]/.test(this.password) && /\d/.test(this.password)) {
          this.passwordStrength = 'strong'
        } else {
          this.passwordStrength = 'good'
        }
      } else {
        this.passwordStrength = 'weak'
      }
    },
    setFieldValue (value, field) {
      this[field] = value
    },
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

/* TODO: Move these to Settings and use as base (overwrites here only) */
.details {
  width: 90%;
  //max-width: 460px;
  margin: 0 auto;
  text-align: center;

  p {
    @include font('content--md', $white, 0.9);
    width: 90%;
    margin: 1.5rem auto;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--lg', $white, 0.9);
      margin: 1.5rem auto;
    }
  }
}

h1, h2 {
  @include font('header--xl', $white, 0.9);
  width: 90%;
  margin: 0 auto;
  text-align: center;

  @media screen and (min-width: $breakpointLg) {
    @include font('header--xxl', $white, 0.9);
    margin: 0 auto;
  }
}

p {
  @include font('content--md', $white);

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white);
  }
}

.highlight {
  border-bottom: 1px dotted $white;
  color: $white !important;
}

</style>
